export function numberFormat(num, removeComma = false) {
    const formattedNumber = num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    return removeComma ? formattedNumber.replace(/,/g, '') : formattedNumber;
}
